import { baseShadowStyle } from '../../style/base-shadow';
import { COLORS } from '../../config/colors/colors';
import { styled } from 'goober';
import React from 'react';
import { WRAPPER_GAP, WRAPPER_PADDING } from './constants';

export const Wrapper = styled('div')<{ $height: number | 'auto' }>`
    display: flex;
    height: ${({ $height }) => (typeof $height === 'number' ? `${$height}px` : $height)};
    padding: ${WRAPPER_PADDING}px;
    border-radius: 20px;
    gap: ${WRAPPER_GAP}px;
    flex-direction: column;
    overflow: hidden;
    transition: height 0.15s ease;
    background-color: ${COLORS.neutral_00};
    will-change: height;
    ${baseShadowStyle}
`;

export const Header = styled('div', React.forwardRef)`
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
`;

export const IconWrapper = styled('div')`
    cursor: pointer;
    user-select: none;
`;

export const Body = styled('ul', React.forwardRef)<{ isOpened: boolean }>`
    display: flex;
    flex-direction: column;
    opacity: ${({ isOpened }) => Number(isOpened)};
    transition: opacity 0.1s ease;
`;
